import { css } from '@huspy/styled-system/css';

export const bankProductsTable = css({
  width: '100%',
  overflow: 'auto',
  boxShadow: '0px 4px 24px 0px rgba(0, 0, 0, 0.06)',
});
